import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { AdminCategory } from './../../models/admin-category.model';
import { AdminCategoryUpdate } from './../../models/admin-category-update.model';
import { CategoryUpdate } from './../../models/category-update.model';
import { Category, Category_v2, Subcategory_v2, SubcategoryUpdate_v2, CategoryResult } from './../../models/category.model';
import { Product } from './../../models/product.model';
import { CategoryProduct } from './../../models/category-product.model';

import { ErrorService } from './../utility/error.service';
import { RestService } from './../base/rest.service';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends RestService {

  endpointUrl: string;
  categories: Category[];

  constructor(
    private http: HttpClient,
    private readonly errorService: ErrorService
  ) {
    super(http, errorService);
    this.endpointUrl = '/api/Category';
  }

  public getCategories(): Observable<Category[]> {
    const url = `${this.endpointUrl}`;
    return this.get<Category[]>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getCategories_v2(): Observable<Category_v2[]> {
    const url = `${this.endpointUrl}/v2`;
    return this.get<Category_v2[]>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getAdminCategories(): Observable<AdminCategory[]> {
    const url = `${this.endpointUrl}`;
    return this.get<AdminCategory[]>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getCategory(categoryId: number): Observable<AdminCategory> {
    const url = `${this.endpointUrl}/${categoryId}`;

    return this.get<AdminCategory>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getCategory_v2(categoryId: number): Observable<Category_v2> {
    const url = `${this.endpointUrl}/${categoryId}/v2`;

    return this.get<Category_v2>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getSubcategories(parentId: number) {
    const url = `${this.endpointUrl}/${parentId}/subcategories`;

    return this.get<AdminCategory>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getSubcategories_v2(parentId: number): Observable<Subcategory_v2[]> {
    const url = `${this.endpointUrl}/${parentId}/subcategories/v2`;

    return this.get<Subcategory_v2[]>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public getProducts(categoryId: number): Observable<CategoryProduct> {
    const url = `${this.endpointUrl}/${categoryId}/products`;
    return this.get<CategoryProduct>(url)
      .pipe(
          catchError(this.errorService.handleError)
      );
  }

  public getProduct(productId: number): Observable<Product> {
    const url = `${this.endpointUrl}/products/${productId}`;

    return this.get<Product>(url)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public createCategory(category: AdminCategory): Observable<AdminCategory> {
    const url = `${this.endpointUrl}`;

    return this.post<AdminCategory>(url, category)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public updateCategory(category: CategoryUpdate): Observable<CategoryUpdate> {
    const url = `${this.endpointUrl}/${category.id}`;

    return this.put<CategoryUpdate>(url, category)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  public upsertSubcategory(parentCategoryId: number, subcategory: SubcategoryUpdate_v2): Observable<CategoryResult> {    
    const url = `${this.endpointUrl}/${parentCategoryId}/subcategories/v2`;

    return this.post<CategoryResult>(url, subcategory)
      .pipe(
        catchError(this.errorService.handleError)
      );
  }

  
}
